export const CLUSTER_ZOOM_LEVEL = 10

export const defaultFilters: Record<string, any> = {
  types: ['sale', 'lease'],
  statuses: ['active', 'pending', 'reduced'],
}

export const PROPERTY_TYPES_COLORS = [
  {
    value: 'orange',
    propertyType: 'Healthcare',
    className: 'bg-[#fb923c] hover:bg-[#fb923c]',
  },
  {
    value: 'pink',
    propertyType: 'Hospitality',
    className: 'bg-[#fb7185] hover:bg-[#fb7185]',
  },
  {
    value: 'slate',
    propertyType: 'Industrial',
    className: 'bg-[#475569] hover:bg-[#475569]',
  },
  {
    value: 'emerald',
    propertyType: 'Investment',
    className: 'bg-[#34d399] hover:bg-[#34d399]',
  },
  {
    value: 'indigo',
    propertyType: 'Land',
    className: 'bg-[#818cf8] hover:bg-[#818cf8] text-[#030712]',
  },
  {
    value: 'fuchsia',
    propertyType: 'Multifamily',
    className: 'bg-[#e879f9] hover:bg-[#e879f9]',
  },
  {
    value: 'yellow',
    propertyType: 'Office',
    className: 'bg-[#fde047] hover:bg-[#fde047] text-[#030712]',
  },
  {
    value: 'cyan',
    propertyType: 'Retail',
    className: 'bg-[#22d3ee] hover:bg-[#22d3ee] text-[#030712]',
  },
  {
    value: 'stone',
    propertyType: 'Other',
    className: 'bg-[#a8a29e] hover:bg-[#a8a29e]',
  },
]

export const TYPES: { [key: string]: string } = {
  sale: 'Sale',
  lease: 'Lease',
  'sale/lease': 'Sale/Lease',
}

export const STATUSES: { [key: string]: string } = {
  active: 'Active',
  pending: 'Pending',
  reduced: 'Reduced',
  leased: 'Leased',
  sold: 'Sold',
  off_market: 'Off Market',
}

export const PROPERTY_TYPES: string[] = [
  'Healthcare',
  'Hospitality',
  'Industrial',
  'Investment',
  'Land',
  'Multifamily',
  'Office',
  'Retail',
  'Other',
]

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiY2FtZXJvbi1yZXNpbXBsaWZpIiwiYSI6ImNremc0cHI5aTAyNHgybnBocWV4NHNoY2MifQ.JAWWThmFY0TwUARWnv1ctA'

export const REGRID_TOKEN =
  'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJyZWdyaWQuY29tIiwiaWF0IjoxNzQxNjQyNjU4LCJnIjo3NDY3OCwidCI6MSwiY2FwIjoicGE6dHM6cHMiLCJ0aSI6MzkxfQ.r8ywmqM9f7hTdmwAj2W6HuJCPOwaPK8DaDDLSUJyv_4'

// prettier-ignore
export const STATE_ABBRS = ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VI','VA','WA','WV','WI','WY',]
